/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-magic-numbers

const MAX_URL_TITLE = 50;
const HEX_COLOR_LENGTH = 6;

const RENDER_SAFE_HTML_WHITELIST_ATTRIBUTES = {
  'class': true,
};

export function createLink(url: string, title?: string): string {
  let urlTitle;

  if (title) {
    urlTitle = title;
  } else {
    urlTitle = url.substring(0, MAX_URL_TITLE);
    if (url.length > MAX_URL_TITLE) {
      urlTitle += '...';
    }
  }

  return `<a target="_blank" href="${url}">${urlTitle}</a>`;
}

export function underlineText(text: string): string {
  return `<u>${text}</u>`;
}

export function colorLuminance(hex: string, lum: number = 0): string {
  // Validate HEX color
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < HEX_COLOR_LENGTH) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  let rgb = '#';
  for (let i = 0; i < 3; i++) {
    const color = parseInt(hex.substr(i * 2, 2), 16);
    const final = Math.round(Math.min(Math.max(0, color + (color * lum)), 255)).toString(16);
    rgb += ('00' + final).substr(final.length);
  }

  return rgb;
}

export function renderSafeHtml(startElement: Element): string {
  const stack: { node: Node; start: boolean }[] = [{ node: startElement, start: true }];
  const buffer: string[] = [];

  while (stack.length) {
    const { node, start } = stack.pop()!; // tslint:disable-line:no-non-null-assertion
    switch (node.nodeType) {
      case Node.ELEMENT_NODE: {
        const element = <Element>node;
        const { attributes, childNodes } = element;

        if (start) {
          buffer.push('<', element.tagName.toLowerCase());
          for (let i = 0; i < attributes.length; i++) {
            const attr = attributes.item(i)!; // tslint:disable-line:no-non-null-assertion
            if (RENDER_SAFE_HTML_WHITELIST_ATTRIBUTES[attr.name]) {
              buffer.push(' ', attr.name, '=', '"', attr.value.replace(/"/g, '&quot;'), '"');
            }
          }
          buffer.push('>');

          stack.push({ node: element, start: false });
          for (let i = childNodes.length - 1; i >= 0; i--) {
            stack.push({ node: childNodes.item(i)!, start: true }); // tslint:disable-line:no-non-null-assertion
          }
        } else {
          buffer.push('</', element.tagName.toLowerCase(), '>');
        }

        break;
      }
      case Node.TEXT_NODE:
        buffer.push(node.textContent || '');
        break;
      default:
        break;
    }
  }

  return buffer.join('');
}
